import { Component } from '@angular/core';
import { DTOInformacaoUsuario } from '../../dto/dtoInfomacaoUsuario';
import { NavParams } from 'ionic-angular';
import moment from 'moment';
moment.locale('pt-BR');

@Component({
    selector: 'visualiza-imagem-page',
    templateUrl: './visualiza-imagem.html'
})
export class VisualizaImagemPage {
    public usuario: DTOInformacaoUsuario;
    public imagem: string;

    constructor(_navParams: NavParams) {        
        this.imagem = _navParams.get('img');
        console.log(this.imagem);
    
    }


}


// WEBPACK FOOTER //
// ./src/pages/visualiza-imagem/visualiza-imagem.ts